import PropTypes from 'prop-types';
import React from 'react';

export class BitmapSVG extends React.Component {
  static propTypes = {
    bitmap: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
  };

  render() {
    const svgStyle = {
      width: this.props.width,
      height: this.props.height,
    };
    return (
      <svg style={svgStyle} xmlns='http://www.w3.org/2000/svg'>
        <image
          width={this.props.width}
          height={this.props.height}
          xlinkHref={`data:image/svg+xml;base64,${this.props.bitmap}`}
        />
      </svg>
    );
  }
}

export default BitmapSVG;
